/* @flow */
import React from 'react';

const Error401 = () => (
  <div>
    <h1>401 Authorization Required.</h1>
    <h2>
      The server could not verify that you are authorized to access the requested document.
      If you have any questions, please contact the site administrator.
    </h2>
  </div>
);

export default Error401;



// WEBPACK FOOTER //
// ./src/components/Errors/Error401.js